<template>
        <div>
          {{total_ytd}}
        </div>
			
</template>

  <script>
	  export default {
		  mounted() {
			 // console.log('Payslip started..');   
		  },
		  props: ['employee_id', 'fiscal_year', 'payslip_id', 'month'],
				 
   
		  data() {
			  
			  return {
				  emp_id: this.employee_id,  
                  fisc_year: this.fiscal_year, 
                  pslip_id: this.payslip_id, 
                  total_ytd:'0',
                  current_headvalue:'0',
                  mnth:this.month
			  }
		  },
		  
		  methods:{
		  

			  
			  getheadytdtotal: function()
			  {
  
						  axios.get(this.$api_url+'/get-head-ytd-total/'+this.emp_id+'/'+this.fisc_year+'/'+this.pslip_id+'/'+this.mnth , {
							  params: {
								  status: '',
							  }
					  }).then(function(response){
					  this.total_ytd =response.data.ytdtotal;
  
  
				  }.bind(this));
			  },
              
              
              failed_request_recovery: function()
			  {
			       if(this.total_ytd=='0')
                   {
                   //alert(1);
                   this.getheadytdtotal();
                   }
			  },

			  
  
		  },
		  created: function(){
		  
		     this.getheadytdtotal();
             setInterval(this.failed_request_recovery, 4000);

			 	
		  }
	  }
  </script>